<template>
    <div class="row soloTexto">
        <span class="text-justify" v-for="contenidoDeLaPaginaWeb in seccionDeLaPaginaWeb.ContenidosDeLaPaginaWeb" v-bind:key="contenidoDeLaPaginaWeb.ContenidoDeLaPaginaWebId">{{contenidoDeLaPaginaWeb.TextoDelContenido}}</span>
    </div>
</template>

<script>
export default {
    props: {
        seccionDeLaPaginaWeb: Object
    }
}
</script>

<style scoped>
  .soloTexto {
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Formatos/SoloTexto.vue